import axios from "axios";

axios.defaults.baseURL =
  "https://preparation-time-tracker-backend.onrender.com/";
